(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (!window.CityState || !window.scCartConfig) return;

    var FALLBACK_DELIVERY_SLOT = (window.scCartConfig.fulfillmentText && window.scCartConfig.fulfillmentText.timeRanges && window.scCartConfig.fulfillmentText.timeRanges.delivery) || '2pm - 10pm';
var FALLBACK_PICKUP_SLOT = '1:00 pm - 5 pm';
    var FULFILLMENT_SELECTION_TTL_MINUTES = 15;

    var t = (window.scCartConfig && window.scCartConfig.fulfillmentText) || {};

    var root = document.querySelector('[data-cart-fulfillment]');
    var form = document.querySelector('form[data-cart-content]');
    var popup = document.querySelector('[data-fulfillment-popup]');
    if (!root || !form || !popup) return;

    var customCheckoutBtn = root.querySelector('[data-cart-checkout-trigger]');

    var servicesWrap = popup.querySelector('[data-services-wrap]');
    var serviceButtons = popup.querySelectorAll('[data-service]');
    var deliveryButton = popup.querySelector('[data-service="delivery"]');
    var pickupButton = popup.querySelector('[data-service="pickup"]');

    var dateCardsWrap = popup.querySelector('[data-date-cards]');
    var dateHeading = popup.querySelector('[data-date-heading]');
    var serviceNote = popup.querySelector('[data-service-note]');
    var pickupMapWrap = popup.querySelector('[data-pickup-map-wrap]');
    var pickupMapIframe = popup.querySelector('[data-pickup-map-iframe]');
    var deliveryInstructionsWrap = popup.querySelector('[data-delivery-instructions-wrap]');

    var instructionChips = popup.querySelectorAll('[data-instruction-chip]');
    var deliveryNoteInput = popup.querySelector('[data-delivery-note-input]');

    var summaryWrap = root.querySelector('[data-fulfillment-summary-wrap]');
    var summaryService = root.querySelector('[data-fulfillment-summary-service]');
    var summaryText = root.querySelector('[data-fulfillment-summary-text]');
    var errorBox = root.querySelector('[data-cart-fulfillment-error]');
    var cityLabel = popup.querySelector('[data-cart-city-label]');
    var continueBtn = popup.querySelector('[data-continue-fulfillment]');

    var openButtons = document.querySelectorAll('[data-open-fulfillment-popup]');
    var closeButtons = popup.querySelectorAll('[data-close-fulfillment-popup]');

    var attrCity = root.querySelector('[data-cart-attr-city]');
    var attrService = root.querySelector('[data-cart-attr-service]');
    var attrDeliveryDate = root.querySelector('[data-cart-attr-delivery-date]');
    var attrDate = root.querySelector('[data-cart-attr-date]');
    var attrTime = root.querySelector('[data-cart-attr-time]');
    var attrLang = root.querySelector('[data-cart-attr-lang]');
    var attrInstructions = root.querySelector('[data-cart-attr-instructions]');
    var attrInstructionNote = root.querySelector('[data-cart-attr-instruction-note]');
    var attrFulfillmentSelectedAt = root.querySelector('[data-cart-attr-fulfillment-selected-at]');

    var activeService = normalizeService(attrService ? attrService.value : '');
    var slotData = [];
    var selectedDate = attrDate ? (attrDate.value || '') : '';
    var selectedInstructions = parseInstructions(attrInstructions ? attrInstructions.value : '');
    var freeTextInstruction = attrInstructionNote ? (attrInstructionNote.value || '') : '';
    var isSubmittingCheckout = false;
    var isResettingCity = false;

    if (deliveryNoteInput) {
      deliveryNoteInput.value = freeTextInstruction;
    }

    function normalizeService(value) {
      return (value || '').toString().trim().toLowerCase();
    }

    function parseInstructions(value) {
      if (!value) return [];
      return value
        .split(',')
        .map(function (item) { return item.trim(); })
        .filter(Boolean);
    }

    function normalizeBoolean(value) {
      if (value === true || value === 1) return true;
      if (value === false || value === 0 || value == null) return false;

      var str = String(value).trim().toLowerCase();
      return str === 'true' || str === '1' || str === 'yes';
    }

    function normalizeNumber(value) {
      if (typeof value === 'number') {
        return isNaN(value) ? 0 : value;
      }

      var cleaned = String(value == null ? '' : '').replace(/[^\d.-]/g, '').trim();
      if (!cleaned) return 0;

      var parsed = Number(cleaned);
      return isNaN(parsed) ? 0 : parsed;
    }

    function getFulfillmentSelectedAt() {
      var fromInput = attrFulfillmentSelectedAt ? (attrFulfillmentSelectedAt.value || '') : '';
      var fromRoot = root.getAttribute('data-fulfillment-selected-at') || '';

      return fromInput || fromRoot || '';
    }

    function setFulfillmentSelectedAt(value) {
      var safeValue = value || '';

      root.setAttribute('data-fulfillment-selected-at', safeValue);

      if (attrFulfillmentSelectedAt) {
        attrFulfillmentSelectedAt.value = safeValue;
      }
    }

    function isFulfillmentSelectionExpired() {
      if (!selectedDate) return false;

      var selectedAt = getFulfillmentSelectedAt();

      if (!selectedAt) return true;

      var selectedTime = new Date(selectedAt).getTime();

      if (!selectedTime || isNaN(selectedTime)) return true;

      var now = Date.now();
      var diffMinutes = (now - selectedTime) / 1000 / 60;

      return diffMinutes > FULFILLMENT_SELECTION_TTL_MINUTES;
    }

    function clearExpiredFulfillmentSelection() {
      if (!isFulfillmentSelectionExpired()) {
        return Promise.resolve(false);
      }

      selectedDate = '';

      if (attrDate) attrDate.value = '';
      if (attrTime) attrTime.value = '';
      if (attrDeliveryDate) attrDeliveryDate.value = '';

      setFulfillmentSelectedAt('');

      clearSelectedUiOnly();
      updateSummary();
      updateCheckoutButtonLabel();

      return syncCartState().then(function () {
        return true;
      });
    }

    function showError(message) {
      if (!errorBox) return;
      errorBox.hidden = !message;
      errorBox.textContent = message || '';
    }

    function getSelectedCity() {
      return window.CityState.get();
    }

    function getSelectedCityLabel() {
      var city = getSelectedCity();
      return city ? window.CityState.getLabel(city) : '';
    }

    function getSlotCityCode() {
      var city = getSelectedCity();
      if (!city) return '';
      return (window.scCartConfig.slotCityMap || {})[city] || '';
    }

    function isPickupAllowed() {
      return getSelectedCity() === 'jeddah';
    }

    function getServiceLabel(service) {
      if (!service) return '';
      return service === 'pickup'
        ? (t.pickup || 'Pickup')
        : (t.delivery || 'Delivery');
    }

    function hasValidSelection() {
      return !!(
        activeService &&
        selectedDate &&
        attrDate && attrDate.value &&
        attrTime && attrTime.value
      );
    }

    function getDisplayTime(slot) {
  if (activeService === 'pickup') {
    return FALLBACK_PICKUP_SLOT;
  }

  var apiTime = (slot && slot.time ? String(slot.time) : '').trim();
  if (apiTime) return apiTime;

  return FALLBACK_DELIVERY_SLOT;
}

    function openPopup() {
      popup.hidden = false;
      document.documentElement.classList.add('sc-popup-open');

      if (!activeService) {
        setActiveService('delivery');
      } else if (!slotData.length) {
        fetchSlots(activeService);
      }
    }

    function closePopup() {
      popup.hidden = true;
      document.documentElement.classList.remove('sc-popup-open');
    }

    function setCityUi() {
      var label = getSelectedCityLabel();
      if (cityLabel) cityLabel.textContent = label || t.selectCity || 'Select city';
      if (attrCity) attrCity.value = label || '';
      if (attrLang) attrLang.value = window.scCartConfig.locale || '';
    }

    function updateCheckoutButtonLabel() {
      if (!customCheckoutBtn) return;
      customCheckoutBtn.textContent = hasValidSelection()
        ? (t.checkout || 'Checkout')
        : (t.chooseDeliveryMethod || 'Choose delivery method');
    }

    function parseApiDate(dateString) {
      var parts = (dateString || '').split('/');
      if (parts.length !== 3) return null;
      return {
        day: parts[0],
        month: parts[1],
        year: parts[2]
      };
    }

    function formatSummaryDate(dateString) {
      var parts = parseApiDate(dateString);
      if (!parts) return dateString || '';
      var monthLabel = (t.months && t.months[parts.month]) || parts.month;
      return parts.day + ' ' + monthLabel + ' ' + parts.year;
    }

    function updateSummary() {
      if (!summaryWrap || !summaryService || !summaryText) return;

      if (!hasValidSelection()) {
        summaryWrap.hidden = true;
        summaryService.textContent = '';
        summaryText.textContent = '';
        updateCheckoutButtonLabel();
        return;
      }

      summaryWrap.hidden = false;
      summaryService.textContent = getServiceLabel(activeService);
      summaryText.textContent = formatSummaryDate(selectedDate) + ' · ' + (attrTime ? attrTime.value : '');
      updateCheckoutButtonLabel();
    }

    function setServiceMessage() {
      if (!serviceNote) return;

      if (activeService === 'pickup') {
        serviceNote.textContent = t.pickupNote || 'Pickup is available only in Jeddah. All pickup orders must be prepaid online.';
      } else {
        serviceNote.textContent = t.deliveryNote || 'Our deliveries run between 2:00PM and 10:00PM. We cannot accommodate specific delivery time.';
      }
    }

    function toggleServiceSections() {
      var isPickup = activeService === 'pickup';

      if (pickupMapWrap) {
        pickupMapWrap.hidden = !isPickup;
      }

      if (pickupMapIframe && isPickup && window.scCartConfig.pickupMapUrl && !pickupMapIframe.src) {
        pickupMapIframe.src = window.scCartConfig.pickupMapUrl;
      }

      if (deliveryInstructionsWrap) {
        deliveryInstructionsWrap.hidden = isPickup;
      }
    }

    function syncServiceVisibility() {
      var pickupAllowed = isPickupAllowed();

      if (pickupButton) pickupButton.style.display = pickupAllowed ? '' : 'none';
      if (deliveryButton) deliveryButton.style.display = '';
      if (servicesWrap) servicesWrap.style.display = pickupAllowed ? '' : 'none';

      if (!pickupAllowed && activeService === 'pickup') {
        activeService = 'delivery';
        if (attrService) attrService.value = 'delivery';
      }

      serviceButtons.forEach(function (btn) {
        var service = btn.getAttribute('data-service');
        btn.classList.toggle('is-active', service === activeService);
      });
    }

    function clearSelectedUiOnly() {
      if (dateCardsWrap) {
        dateCardsWrap.querySelectorAll('.sc-cart-date-card').forEach(function (card) {
          card.classList.remove('is-selected');
        });
      }
    }

    function clearDateSelection(options) {
      options = options || {};

      selectedDate = '';
      slotData = [];

      if (dateCardsWrap) dateCardsWrap.innerHTML = '';
      if (attrDate) attrDate.value = '';
      if (attrTime) attrTime.value = '';
      if (attrDeliveryDate) attrDeliveryDate.value = '';

      setFulfillmentSelectedAt('');

      if (!options.skipSummary) {
        updateSummary();
      }
    }

    function clearFulfillmentSelection(options) {
      options = options || {};

      selectedDate = '';
      slotData = [];

      if (attrDate) attrDate.value = '';
      if (attrTime) attrTime.value = '';
      if (attrDeliveryDate) attrDeliveryDate.value = '';

      setFulfillmentSelectedAt('');

      if (options.clearService) {
        activeService = '';
        if (attrService) attrService.value = '';
      }

      if (dateCardsWrap) {
        dateCardsWrap.innerHTML = '';
      }

      if (summaryWrap) {
        summaryWrap.hidden = true;
      }

      if (summaryService) {
        summaryService.textContent = '';
      }

      if (summaryText) {
        summaryText.textContent = '';
      }

      updateCheckoutButtonLabel();
    }

    function setActiveService(service) {
      if (service === 'pickup' && !isPickupAllowed()) {
        service = 'delivery';
      }

      activeService = service || 'delivery';
      if (attrService) attrService.value = activeService;

      serviceButtons.forEach(function (btn) {
        var btnService = btn.getAttribute('data-service');
        btn.classList.toggle('is-active', btnService === activeService);
      });

      setServiceMessage();
      toggleServiceSections();
      clearDateSelection();
      fetchSlots(activeService);
    }

    function formatCardParts(dateString) {
      var parts = parseApiDate(dateString);
      if (!parts) {
        return { daynum: '', month: dateString || '' };
      }

      return {
        daynum: parts.day,
        month: (t.months && t.months[parts.month]) || parts.month
      };
    }

    function buildIsoDate(displayDate) {
  var parts = parseApiDate(displayDate);
  if (!parts) return '';

  var monthMap = {
    Jan: 0, Feb: 1, Mar: 2, Apr: 3,
    May: 4, Jun: 5, Jul: 6, Aug: 7,
    Sep: 8, Oct: 9, Nov: 10, Dec: 11
  };

  var monthIndex = monthMap[parts.month];
  if (typeof monthIndex === 'undefined') return '';

  var year = Number(parts.year);
  var day = Number(parts.day);

  if (!year || !day) return '';

  /*
    SKU Labs expects UTC format.
    Delivery date represents midnight in Saudi Arabia.
    Saudi Arabia is UTC+3, so local 00:00 becomes previous day 21:00Z.
  */
  var utcDate = new Date(Date.UTC(year, monthIndex, day, 0, 0, 0));
  utcDate.setUTCHours(utcDate.getUTCHours() - 3);

  return utcDate.toISOString()
    .replace(':00.000Z', 'Z');
}

    function formatDayLabel(item, index) {
      if (index === 0) return t.today || 'Today';
      if (index === 1) return t.tomorrow || 'Tomorrow';
      return (t.days && t.days[item.day]) || item.day || t.available || 'Available';
    }

    function isTodaySlot(dateString) {
      var parts = parseApiDate(dateString);
      if (!parts) return false;

      var monthMap = {
        Jan: 0, Feb: 1, Mar: 2, Apr: 3,
        May: 4, Jun: 5, Jul: 6, Aug: 7,
        Sep: 8, Oct: 9, Nov: 10, Dec: 11
      };

      var monthIndex = monthMap[parts.month];
      if (typeof monthIndex === 'undefined') return false;

      var now = new Date();

      return (
        now.getDate() === Number(parts.day) &&
        now.getMonth() === monthIndex &&
        now.getFullYear() === Number(parts.year)
      );
    }

    function getSameDayCutoffHour(cityLabel, service) {
      var city = (cityLabel || '').toString().trim().toLowerCase();
      var normalizedService = normalizeService(service);

      if (normalizedService === 'pickup') {
        return 16;
      }

      if (city === 'jeddah' || city === 'riyadh' || city === 'dammam') return 12;
      if (city === 'taif') return 8;
      if (city === 'medina') return 8;
      if (city === 'al hasa') return 9;

      return 11;
    }

    function isPastSameDayCutoff(dateString, service) {
      if (!isTodaySlot(dateString)) return false;

      var cityLabelValue = getSelectedCityLabel();
      var cutoffHour = getSameDayCutoffHour(cityLabelValue, service);
      var now = new Date();

      return now.getHours() >= cutoffHour;
    }

    function getSlotState(slot) {
      var enabled = normalizeBoolean(slot.enable);
      var remaining = normalizeNumber(slot.remaining);

      if (enabled && remaining <= 0) {
        return 'fully_booked';
      }

      if (isPastSameDayCutoff(slot.date, activeService)) {
        return 'fully_booked';
      }

      if (!enabled) {
        return 'day_off';
      }

      return 'available';
    }

    function selectDate(date, btn, item) {
      selectedDate = date;

      clearSelectedUiOnly();

      if (btn) btn.classList.add('is-selected');

      if (attrDate) attrDate.value = date;
      if (attrDeliveryDate) attrDeliveryDate.value = buildIsoDate(date);
      if (attrTime) attrTime.value = getDisplayTime(item);

      setFulfillmentSelectedAt(new Date().toISOString());

      syncCartState();
      showError('');
    }

    function renderDateCards() {
      if (!dateCardsWrap) return;

      dateCardsWrap.innerHTML = '';

      if (!slotData.length) {
        showError(t.noSlots || 'No slots available right now.');
        return;
      }

      if (dateHeading) {
        dateHeading.textContent =
          activeService === 'pickup'
            ? (t.selectPickupDay || 'Select available day for pickup')
            : (t.selectDeliveryDay || 'Select available day for delivery');
      }

      slotData.forEach(function (item, index) {
        if (!item.date) return;

        var parts = formatCardParts(item.date);
        var btn = document.createElement('button');
        var state = getSlotState(item);

        btn.type = 'button';
        btn.className = 'sc-cart-date-card';

        if (state === 'available' && selectedDate === item.date) {
          btn.classList.add('is-selected');
        }

        if (state !== 'available') {
          btn.classList.add('is-disabled');
          btn.disabled = true;
        }

        var badgeHtml = '';
        if (state === 'available') {
          badgeHtml = '<div class="sc-cart-date-card__slot">' + getDisplayTime(item) + '</div>';
        } else if (state === 'fully_booked') {
          badgeHtml = '<div class="sc-cart-date-card__full">' + (t.fullyBooked || 'Fully booked') + '</div>';
        } else {
          badgeHtml = '<div class="sc-cart-date-card__full sc-cart-date-card__dayoff">' + (t.dayOff || 'Day off') + '</div>';
        }

        btn.innerHTML =
          '<div>' +
            '<div class="sc-cart-date-card__daynum">' + parts.daynum + '</div>' +
            '<div class="sc-cart-date-card__month">' + parts.month + '</div>' +
            '<div class="sc-cart-date-card__label">' + formatDayLabel(item, index) + '</div>' +
          '</div>' +
          badgeHtml;

        if (state === 'available') {
          btn.addEventListener('click', function () {
            selectDate(item.date, btn, item);
          });
        }

        dateCardsWrap.appendChild(btn);
      });
    }

    function fetchSlots(service) {
      showError('');

      var slotType = service === 'pickup' ? 1 : 0;
      var cityCode = getSlotCityCode();

      if (!cityCode) {
        showError(t.selectCityFirst || 'Please select your city first.');
        return;
      }

      fetch(window.scCartConfig.slotApiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: new URLSearchParams({
          action: 'get_time',
          slot_type: String(slotType),
          dev: '1',
          lang: window.scCartConfig.locale || 'en',
          city: cityCode
        })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (!data || data.status !== true || !Array.isArray(data.data)) {
            slotData = [];
            if (dateCardsWrap) dateCardsWrap.innerHTML = '';
            showError(t.noSlots || 'No slots available right now.');
            return;
          }

          slotData = data.data.map(function (row) {
            return {
              date: (row.date || '').toString().trim(),
              day: (row.day || '').toString().trim(),
              time: (row.time || '').toString().trim(),
              enable: normalizeBoolean(row.enable),
              remaining: normalizeNumber(row.remaining),
              used: normalizeNumber(row.used),
              limit: normalizeNumber(row.limit)
            };
          });

          renderDateCards();
        })
        .catch(function (err) {
          console.warn('slot fetch error', err);
          slotData = [];
          if (dateCardsWrap) dateCardsWrap.innerHTML = '';
          showError(t.unableToLoadSlots || 'Unable to load slots right now.');
        });
    }

    function getSelectedInstructionsValue() {
      return selectedInstructions.join(', ');
    }

    function updateInstructionUi() {
      instructionChips.forEach(function (chip) {
        var value = chip.getAttribute('data-instruction-chip') || '';
        chip.classList.toggle('is-selected', selectedInstructions.indexOf(value) > -1);
      });

      if (attrInstructions) attrInstructions.value = getSelectedInstructionsValue();
      if (attrInstructionNote) attrInstructionNote.value = freeTextInstruction || '';
    }

    function syncCartState() {
      updateInstructionUi();
      updateSummary();
      updateCheckoutButtonLabel();

      var payload = {
        attributes: {
          'City': attrCity ? attrCity.value : '',
          'Service': attrService ? attrService.value : '',
          'Delivery Date': attrDeliveryDate ? attrDeliveryDate.value : '',
          'Date': attrDate ? attrDate.value : '',
          'Time': attrTime ? attrTime.value : '',
          'Fulfillment Selected At': getFulfillmentSelectedAt(),
          'lang': attrLang ? attrLang.value : '',
          'Delivery Instructions': attrInstructions ? attrInstructions.value : '',
          'Delivery Note': attrInstructionNote ? attrInstructionNote.value : ''
        }
      };

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      }).catch(function (err) {
        console.warn('cart sync failed', err);
      });
    }

    function submitCheckout() {
      if (isSubmittingCheckout || !form) return;
      isSubmittingCheckout = true;

      try {
        if (form.requestSubmit) {
          var tempBtn = document.createElement('button');
          tempBtn.type = 'submit';
          tempBtn.name = 'checkout';
          tempBtn.value = '1';
          tempBtn.style.display = 'none';
          form.appendChild(tempBtn);
          form.requestSubmit(tempBtn);

          setTimeout(function () {
            if (tempBtn.parentNode) tempBtn.parentNode.removeChild(tempBtn);
          }, 0);
        } else {
          var hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'checkout';
          hidden.value = '1';
          form.appendChild(hidden);
          form.submit();
        }
      } finally {
        setTimeout(function () {
          isSubmittingCheckout = false;
        }, 1500);
      }
    }

    serviceButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActiveService(btn.getAttribute('data-service'));
      });
    });

    instructionChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var value = chip.getAttribute('data-instruction-chip') || '';
        var index = selectedInstructions.indexOf(value);

        if (index > -1) selectedInstructions.splice(index, 1);
        else selectedInstructions.push(value);

        updateInstructionUi();
        syncCartState();
      });
    });

    if (deliveryNoteInput) {
      var noteTimer;
      deliveryNoteInput.addEventListener('input', function () {
        freeTextInstruction = deliveryNoteInput.value.trim();
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          updateInstructionUi();
          syncCartState();
        }, 300);
      });
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-open-fulfillment-popup]');
      if (openBtn) {
        e.preventDefault();
        openPopup();
        return;
      }

      var closeBtn = e.target.closest('[data-close-fulfillment-popup]');
      if (closeBtn) {
        e.preventDefault();
        closePopup();
        return;
      }
    });

    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        showError('');

        if (!getSelectedCity()) {
          showError(t.selectCityFirst || 'Please select your city first.');
          return;
        }

        if (!activeService) {
          showError(t.chooseService || 'Please choose a service.');
          return;
        }

        if (isFulfillmentSelectionExpired()) {
          clearExpiredFulfillmentSelection().then(function () {
            showError(t.chooseDate || 'Please choose a date.');
          });
          return;
        }

        if (!selectedDate) {
          showError(t.chooseDate || 'Please choose a date.');
          return;
        }

        syncCartState().then(function () {
          closePopup();
          submitCheckout();
        });
      });
    }

    document.addEventListener('click', function (e) {
      var checkoutTrigger = e.target.closest('[data-cart-checkout-trigger]');
      if (!checkoutTrigger) return;

      e.preventDefault();

      if (isFulfillmentSelectionExpired()) {
        clearExpiredFulfillmentSelection().then(function () {
          openPopup();
          showError(t.chooseDate || 'Please choose a date.');
        });
        return;
      }

      if (!hasValidSelection()) {
        openPopup();
        showError('');
        return;
      }

      syncCartState().then(function () {
        submitCheckout();
      });
    });

    document.addEventListener('city:changed', function () {
      if (isResettingCity) return;
      isResettingCity = true;

      setCityUi();
      showError('');

      clearFulfillmentSelection({ clearService: true });
      syncServiceVisibility();
      updateSummary();
      updateCheckoutButtonLabel();

      syncCartState().then(function () {
        activeService = 'delivery';
        if (attrService) attrService.value = 'delivery';

        syncServiceVisibility();
        setServiceMessage();
        toggleServiceSections();
        updateSummary();
        updateCheckoutButtonLabel();
        fetchSlots('delivery');
      }).finally(function () {
        isResettingCity = false;
      });
    });

    setCityUi();

    if (!activeService) {
      activeService = 'delivery';
      if (attrService) attrService.value = 'delivery';
    }

    syncServiceVisibility();
    setServiceMessage();
    toggleServiceSections();
    updateInstructionUi();

    clearExpiredFulfillmentSelection().then(function () {
      updateSummary();
      updateCheckoutButtonLabel();

      if (activeService && !slotData.length) {
        fetchSlots(activeService);
      }
    });
  });
})();

(function () {
  function moveFulfillmentPopupToBody() {
    var popup = document.querySelector('[data-fulfillment-popup]');
    if (!popup) return;

    if (popup.parentElement !== document.body) {
      document.body.appendChild(popup);
    }
  }

  function syncFulfillmentPopupState() {
    var popup = document.querySelector('[data-fulfillment-popup]');
    var isOpen = popup && !popup.hasAttribute('hidden');

    document.documentElement.classList.toggle('sc-fulfillment-popup-open', !!isOpen);
    document.body.classList.toggle('sc-fulfillment-popup-open', !!isOpen);
  }

  function initFulfillmentPopupLayerFix() {
    moveFulfillmentPopupToBody();
    syncFulfillmentPopupState();

    var popup = document.querySelector('[data-fulfillment-popup]');
    if (!popup) return;

    var observer = new MutationObserver(function () {
      syncFulfillmentPopupState();
    });

    observer.observe(popup, {
      attributes: true,
      attributeFilter: ['hidden', 'style', 'class']
    });

    document.addEventListener('click', function () {
      setTimeout(function () {
        moveFulfillmentPopupToBody();
        syncFulfillmentPopupState();
      }, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFulfillmentPopupLayerFix);
  } else {
    initFulfillmentPopupLayerFix();
  }
})();